import { createSlice } from '@reduxjs/toolkit';
import { resetAdminPersistedJourneyState } from 'store/adminJourneyReset';

export interface FlowState {
  currentStep: string | null;
  csvValidationStatus: string | null;
}

const initialState: FlowState = {
  currentStep: null,
  csvValidationStatus: null,
};

const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setCurrentStep(state, action: { payload: string | null }) {
      state.currentStep = action.payload;
    },
    setCsvValidationStatus(state, action: { payload: string | null }) {
      state.csvValidationStatus = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetAdminPersistedJourneyState, () => ({ ...initialState }));
  },
});

export const { setCurrentStep, setCsvValidationStatus } = flowSlice.actions;
export default flowSlice.reducer;
